module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "points-earned",
    class: {
      darkBackground: _vm.darkBackground
    }
  }, [_c('div', [_c('sk-icon', {
    class: _vm.icon
  })], 1), _vm._v(" "), _c('h2', [_vm._t("points")], 2), _vm._v(" "), _c('span', [_vm._v("Points")]), _vm._v(" "), _c('p', [_vm._t("description")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de456c8a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/static-page/featured-points-earned/featured-points-earned.vue
// module id = 921
// module chunks = 0